export function signal(options) {
    return window.paiLaApi.signal(options)

}
window.onload = function () {
    initPlatform();
};

function initPlatform() {
    if (systemInfo.platform !== "mobile") {
        initPc();
    } else if (systemInfo.environment === "APP") {
        // initApp();
    } else {
        initBrowser();
    }
}

window.getShareInfo = function () {
    return {
        title: "国泰君安期货小君直播",
        imageUrl: null,
        desc: null,
        url: window.location.href,
    };
};

function initPc() { }

function initApp() {
    var app = window.app;
}

function initBrowser() { }